<div class="about-container">
  <div class="page-header">
    <h2>About Perse ConsentWallet</h2>
    <p>Version {{ version }}</p>
    <p>Build Date: {{ buildDate }}</p>
  </div>

  <div class="content-container">
    <div class="section">
      <h3>What's New</h3>
      <mat-list>
        <mat-list-item *ngFor="let item of whatsNew">
          <mat-icon matListItemIcon>check_circle</mat-icon>
          <div matListItemTitle>{{ item }}</div>
        </mat-list-item>
      </mat-list>
    </div>
    
    <!-- <div class="section">
      <h3>Known Issues</h3>
      <mat-list>
        <mat-list-item *ngFor="let issue of knownIssues">
          <mat-icon matListItemIcon>warning</mat-icon>
          <div matListItemTitle>{{ issue }}</div>
        </mat-list-item>
      </mat-list>
    </div> -->
  </div>
</div>
